import React, { createContext, useContext, useState, useCallback } from 'react';

const ContactModalContext = createContext(null);

export function ContactModalProvider({ children }) {
  const [contactRequest, setContactRequest] = useState(null);

  const openContact = useCallback((options = {}) => setContactRequest(options), []);
  const closeContact = useCallback(() => setContactRequest(null), []);

  return (
    <ContactModalContext.Provider value={{
      showContact: contactRequest !== null,
      contactRequest,
      openContact,
      closeContact,
    }}>
      {children}
    </ContactModalContext.Provider>
  );
}

export function useContactModal() {
  const ctx = useContext(ContactModalContext);
  if (!ctx) throw new Error('useContactModal must be used within ContactModalProvider');
  return ctx;
}

export default ContactModalContext;
